import React from "react";
import ReactDOM from "react-dom";
import { initSentry } from "lib/sentryHelper";
import Root from "Root";
import registerServiceWorker from "./registerServiceWorker";
import "styles/reset.css";
import "styles/style.css";

initSentry();

ReactDOM.render(<Root />, document.getElementById("root"));
registerServiceWorker();
